export const getInitialState = () => ({
  data: {
    cpf: null
  },
});

export const state = getInitialState();
